module.exports = __webpack_public_path__ + "static/img/bottom.0c1790c5.png";